import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { AuditRow } from "../../../models/AuditRow";
import { AUDIT_TOKENS } from "../../../theme/auditTokens";
import { EmptyValue } from "../../common/EmptyValue";
import { rowDutyRosters } from "../rowValues";

/** Duty roster numbers, with a discreet hint when several app records matched the trip. */
export function DutyRosterCell({ row }: GridRenderCellParams<AuditRow>) {
  const { t } = useTranslation();
  const numbers = rowDutyRosters(row);
  const candidates = row.rowType === "trip" ? row.trip.dutyRosterCandidates : 0;
  if (numbers.length === 0) return <EmptyValue />;
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: "6px", fontVariantNumeric: "tabular-nums", minWidth: 0 }}>
      <Tooltip title={numbers.join(", ")}>
        <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
          {numbers.join(", ")}
        </Box>
      </Tooltip>
      {candidates > 1 && (
        <Tooltip title={t("logbookAudit.grid.multipleDutyRosters", { count: candidates })}>
          <InfoOutlinedIcon
            fontSize="inherit"
            sx={{ color: AUDIT_TOKENS.warn.fg, fontSize: 16 }}
            aria-label={t("logbookAudit.grid.multipleDutyRosters", { count: candidates })}
          />
        </Tooltip>
      )}
    </Box>
  );
}
